<!-- This example requires Tailwind CSS v2.0+ -->
<template>
  <nav class="flex mb-5" aria-label="Breadcrumb" v-if="ishome == 'false'">
    <ol role="list" class="flex items-center space-x-4">
      <li v-for="page in pages">
        <div v-if="page.title == 'Home'">
          <a :href="page.url" class="text-gray-400 hover:text-gray-500">
            <HomeIcon class="flex-shrink-0 h-5 w-5" aria-hidden="true" />
            <span class="sr-only">Home</span>
          </a>
        </div>
        <div class="flex items-center" v-else>
          <ChevronRightIcon class="flex-shrink-0 h-5 w-5 text-gray-400" aria-hidden="true" />
          <a :href="page.url" class="ml-4 text-sm font-medium text-gray-500 hover:text-gray-700" >{{ page.title }}</a>
        </div>
      </li>
    </ol>
  </nav>
</template>

<script>
import { ChevronRightIcon, HomeIcon } from '@heroicons/vue/solid'

export default {
  props: {
      ishome: String,
      pages: Object
  },
  components: {
    ChevronRightIcon,
    HomeIcon,
  }
}
</script>
